import React from 'react'
import { useStyles } from './ConnectorStyle'
export default function Connector() {
    const style = useStyles()
    return (
        <div className={style.connectorDiv}>
            <div className={style.connectortxt}>
                Service has Apache Kafka Connect API disabled
            </div>
            <div className={style.ConnectorButtonsDiv}>
                <button className={style.connectorButton}>Create New Apache Kafka Connect Integration</button>
                <div className={style.orText}>or</div>
                <button className={style.connectorButton2}>Enable Apache Kafka Connect API</button>
            </div>
        </div>
    )
}
